module.exports = __webpack_public_path__ + "static/succulent-1-68b52eef5e3bba42d3e566715148f815.png";